module.exports = __webpack_public_path__ + "assets/pdf/malbec.4f995e96.pdf";